module.exports = __webpack_public_path__ + "img/scenario_07.a13dd376.jpg";